import { Business } from 'lib/types/models';

export enum DocumentOperationOrigin {
  FACTORING = 'FACTORING',
  CONFIRMING = 'CONFIRMING',
}

export interface DocumentToEdit {
  id: string;
  folio?: string;
  stakeholderIdentifier?: string;
  businessIdentifier?: string;
  subType?: string;
  issuedDate?: string | Date;
  amount?: number;
  dueDate?: string | Date;
}

export interface EditDocumentsInput {
  documents: DocumentToEdit[];
  origin?: DocumentOperationOrigin;
}

export interface EditDocumentsOutput {
  updatedDocuments: Array<{
    id: string;
    stakeholderIdentifier: string;
    businessIdentifier: string;
    subType: string | null;
    issuedDate: string;
    amount: number;
    dueDate?: string;
  }>;
  errors: Array<{
    documentId: string;
    error: string;
  }>;
}

export type DocumentSummary = {
  id: string;
  businessIdentifier: string;
  stakeholderIdentifier: string;
  type: string;
  subType?: string | null;
  folio: string;
  issuer?: boolean;
  issuedDate?: string;
  confirmDate?: string | null;
  cancelDate?: string | null;
  amount?: number;
  sgrWarrantyRequestId?: string | null;
  nulledAt?: string | null;
  createdAt?: string | null;
  fatherDocumentId?: string | null;
  pendingAccountId?: string | null;
  businessName: string;
  stakeholderName: string;
  advance: number;
  amountAdvanced: number;
  amountConciliated?: number | null;
  amountConciliatedByCreditNotes?: number | null;
  amountConciliatedByDiscounts?: number | null;
  amountConciliatedByFactoring?: number | null;
  amountConciliatedByFunds?: number | null;
  amountConciliatedByPassives?: number | null;
  amountConciliatedByPayIns?: number | null;
  amountNet: number;
  arrearAmount: number;
  arrearConciliation?: number | null;
  arrearRate?: number;
  business: Business;
  companyId?: number | null;
  conciliationLog?: any[];
  conciliations?: any[];
  conciliationsCreditNotes?: any[];
  conciliationsDiscounts?: any[];
  conciliationsFactoring?: any[];
  conciliationsFunds?: any[];
  conciliationsPassives?: any[];
  conciliationsPayIns?: any[];
  documentAmountDiscounted?: number | null;
  creditRequests?: any[];
  daysToCount?: number | null;
  documentConciliation?: number | null;
  documentRemainingAmount: number;
  documentRemainingAmountDebt?: number | null;
  documentRemainingAmountNet?: number | null;
  extensions?: any[];
  factoringExtensions?: any[];
  factoringQuoteId?: number | null;
  factoringQuotes?: any[];
  interestCost?: number | null;
  operationDate?: string | null;
  paymentDate: string;
  rate: number;
  costRate?: number | null;
  requestId: string;
  reversedAt?: string | null;
  stakeholder?: any;
  startingPaymentDate?: string;
  status?: string | null;
  surplusId?: string | null;
  totalArrear: number;
  totalRemaining: number;
  totalRemainingDebt: number;
  totalRemainingNet: number;
  creditNoteAmount?: number | null;
  invoiceAmount?: number | null;
  fundName?: string | null;
  cessions: {
    giver: string;
    cessionary: string;
    cessionDate: string;
    giverIdentifier: string;
    cessionaryIdentifier: string;
  }[];
};

export interface UpdateArrearRateInput {
  documentId: string;
  arrearType: string;
  arrearRate: number;
  arrearTableId?: number | null;
  hasConciliations: boolean;
  conciliationDate: Date;
}
export interface ArrearTableSegment {
  min: number;
  max: number;
  value: number;
}

export interface ArrearStructure {
  arrearRate: number;
  arrearType: string;
  arrearSegments: ArrearTableSegment[];
}

export interface UpdateArrearRateOutput {
  documentId: string;
  product: 'factoring' | 'confirming' | 'credit';
  arrearTableId: number | null;
  arrearStructure: ArrearStructure;
}
